
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const StoreBasicInfoComponent = ({ onInnerFormChange, selectedStore }: any) => (
          <>
<AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Store Name"
              name="Store Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StoreInfo.StoreName',
                  selectedStore?.StoreInfo
                )
              }}
              type="text"
              value={selectedStore?.StoreInfo?.StoreName}
          />
     
          <InputContainer
              label="Store Phone Number"
              name="Store Phone Number"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StoreInfo.StorePhoneNumber',
                  selectedStore?.StoreInfo
                )
              }}
              type="text"
              value={selectedStore?.StoreInfo?.StorePhoneNumber}
          />
     
       
         <InputContainer
         isDisabled="selectedStore.StoreInfo.Id"
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StoreInfo.CurrencyCode',
                  selectedStore?.StoreInfo
                )
              }}
              type="text"
              value={selectedStore?.StoreInfo?.CurrencyCode}
          />
    <InputContainer

              label="IsActive"
              name="IsActive"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'StoreInfo.IsActive',
                  selectedStore?.StoreInfo
                )
              }}
              type="checkbox"
              value={selectedStore?.StoreInfo?.IsActive}
          />
     </div>
    }
    expandedPanel="basicInfo"
    headerTitle="Basic Info"
/>
</>
)
export default StoreBasicInfoComponent;
